import type { ProductDataDTO } from "~/domains/product/types/ProductDataDTO";
import DataSheetDownload from "~/features/datasheet/components/DataSheetDownload";
import { transformProduct } from "~/features/productDetails/transformers/ProductDataTransformer";

export const createDataSheetPage = ({ product }: { product: string }) => {
  const dto = JSON.parse(product) as ProductDataDTO;
  return <DataSheetDownload product={transformProduct(dto)} />;
};
